import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Typography,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu"; // Hamburger Icon
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import useGoogleSignIn from "../hooks/useGoogleSignIn";
import Logo from "../assets/logo.svg";

const NavBar = () => {
  const userDetails = useSelector((state: RootState) => state.userDetails);
  const { initiateGoogleSignIn, initiateGoogleSignOut } = useGoogleSignIn();
  const [mobileOpen, setMobileOpen] = useState(false);

  // Toggle Mobile Menu
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "#fff", boxShadow: "none" }}>
      <Toolbar>
        {/* Logo */}
        <Link to="/">
          <img src={Logo} alt="Logo" style={{ marginRight: "8px", height: "50px" }} />
        </Link>

        <Typography
          variant="h6"
          noWrap
          component={Link}
          to="/"
          sx={{
            fontWeight: 700,
            color: "#000",
            textDecoration: "none",
            marginRight: "20px",
          }}
        >
          RoamEasy
        </Typography>

        {/* Desktop Navigation Links */}
        <Box sx={{ display: { xs: "none", md: "flex" }, flexGrow: 1 }}>
          <Button color="inherit" component={Link} to="/Explore" sx={navBarStyles}>
            Explore
          </Button>
          <Button color="inherit" component={Link} to="/Save" sx={navBarStyles}>
            Saved
          </Button>
          <Button color="inherit" component={Link} to="/PlanATrip" sx={navBarStyles}>
            Plan a Trip
          </Button>
        </Box>

        {/* Sign In / Sign Out Button */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          {userDetails.userId ? (
            <Button onClick={() => initiateGoogleSignOut()} sx={navBarStyles}>
              Sign Out
            </Button>
          ) : (
            <Button onClick={() => initiateGoogleSignIn()} sx={navBarStyles}>
              Sign In
            </Button>
          )}
        </Box>

        {/* Hamburger Menu for Mobile */}
        <IconButton
          color="inherit"
          aria-label="menu"
          onClick={handleDrawerToggle}
          sx={{
            display: { xs: "flex", md: "none" },
            color: "#000",
            ml: "auto",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
        <Box sx={{ width: 250, textAlign: "center", p: 2, display:"flex", flexDirection: "column", alignItems: "center" }}>
          <IconButton onClick={handleDrawerToggle} sx={{ alignSelf: "flex-end" }}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontWeight: 700, mt: 2, textAlign: "center" }}>
            <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>RoamEasy</Link>
          </Typography>
          <List sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/Explore" onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
                <ListItemText primary="Explore" sx={{ textAlign: "center" }}/>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/Save" onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
                <ListItemText primary="Saved" sx={{ textAlign: "center" }}/>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/PlanATrip" onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
                <ListItemText primary="Plan a Trip" sx={{ textAlign: "center" }}/>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              {userDetails.userId ? (
                <ListItemButton onClick={() => { initiateGoogleSignOut(); handleDrawerToggle(); }} sx={{ textAlign: "center" }}>
                  <ListItemText primary="Sign Out" sx={{ textAlign: "center" }}/>
                </ListItemButton>
              ) : (
                <ListItemButton onClick={() => { initiateGoogleSignIn(); handleDrawerToggle(); }} sx={{ textAlign: "center" }}>
                  <ListItemText primary="Sign In" sx={{ textAlign: "center" }}/>
                </ListItemButton>
              )}
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

// Navbar Button Styles
const navBarStyles = {
  color: "#000",
  textDecoration: "none",
  marginRight: "20px",
  padding: "0px 8px",
  fontFamily: "system-ui",
};

export default NavBar;
